export default "__VITE_ASSET__BP9GYF$v__"